// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","Top":"10000","wrapper":"OptionsWrapper_wrapper__--19w","isExpanded":"OptionsWrapper_isExpanded__etRc6"};